import css from "./.module.scss";

const init = () => {
  if (typeof window === "undefined") return;

  const node = document.createElement("section");
  node.classList.add(css.gui_toast_group);

  document.firstElementChild.insertBefore(node, document.body);
  return node;
};

const createToast = (text, elm) => {
  let rect;
  const node = document.createElement("output");
  if (typeof elm?.getBoundingClientRect === "function") {
    rect = elm?.getBoundingClientRect();
  }
  node.innerText = text;
  node.classList.add(css.gui_toast);
  node.setAttribute("role", "status");
  node.setAttribute("aria-live", "polite");
  if (rect) {
    node.style.position = "absolute";
    node.style.setProperty("--xPos", `${rect.x}px`);
    node.style.setProperty("--_travel-distance", "-150px");
    node.style.setProperty("--yPos", `${rect.y - rect.height - 10}px`);
  } else {
    node.style.translate = `50% 50%`;
  }
  return node;
};

const addToast = (toast) => {
  const { matches: motionOK } = window.matchMedia(
    "(prefers-reduced-motion: no-preference)",
  );

  Toaster.children.length && motionOK
    ? flipToast(toast)
    : Toaster.appendChild(toast);
};

export const Toast = (text, { cls, elm } = {}) => {
  let toast = createToast(text, elm);
  toast.classList.add(css[cls]);
  addToast(toast);

  return new Promise(async (resolve, reject) => {
    await Promise.allSettled(
      toast.getAnimations().map((animation) => animation.finished),
    );
    Toaster.removeChild(toast);
    resolve();
  });
};
Toast.success = (text) => Toast(text, { cls: "success" });

// https://aerotwist.com/blog/flip-your-animations/
const flipToast = (toast) => {
  // FIRST
  const first = Toaster.offsetHeight;

  // add new child to change container size
  Toaster.appendChild(toast);

  // LAST
  const last = Toaster.offsetHeight;

  // INVERT
  const invert = last - first;

  // PLAY
  const animation = Toaster.animate(
    [{ transform: `translateY(${invert}px)` }, { transform: "translateY(0)" }],
    {
      duration: 150,
      easing: "ease-out",
    },
  );

  animation.startTime = document.timeline.currentTime;
};

const Toaster = init();
export default Toast;
